import APIService from '../api';
import { IOfferEdit } from '@/models/offer';

export type SeamlessOfferCreationStatus = 'ready' | 'done';

interface IOfferCreation extends IOfferEdit {
  renewalFrequency: string;
  frequency: string;
  imageUrl: string;
}
export interface ISeamlessOfferCreation {
  businessId: string;
  businessName: string;
  offer: IOfferCreation;
  status: SeamlessOfferCreationStatus;
}

export default class EmailOfferCreationPreviewService extends APIService {
  getOfferCreationDetail(code: string) {
    return this.get<ISeamlessOfferCreation>(`/seamless-offer-creation/${code}`);
  }

  creationOffer(code: string) {
    return this.post(`/seamless-offer-creation/${code}`);
  }
}
